import React from 'react'

export default function Shipping() {
  return (
    <div className="bg-black text-white min-h-screen py-12 px-4">
      <div className="max-w-7xl mx-auto space-y-12">
        <header className="space-y-4">
          <h1 className="text-4xl font-extrabold text-white">Shipping & Exchange Policy</h1>
          <p className="text-lg text-gray-300">
            While Bristu Learning App primarily offers digital content, this policy outlines procedures for any physical products that may be offered.
          </p>
        </header>

        <section className="space-y-10">
          {/* SHIPPING */}
          <div className="bg-gray-900 rounded-2xl p-6 shadow-md space-y-4">
            <h2 className="text-2xl font-bold text-white">Shipping</h2>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li><span className="font-semibold text-white">Shipping Methods:</span> Standard and express shipping options are available for eligible products.</li>
              <li><span className="font-semibold text-white">Shipping Costs:</span> Calculated based on destination, shipping method, and weight.</li>
              <li><span className="font-semibold text-white">Shipping Times:</span> Orders typically arrive within 5–10 business days.</li>
              <li><span className="font-semibold text-white">Shipping Restrictions:</span> Currently limited to domestic delivery. International shipping is not supported.</li>
              <li><span className="font-semibold text-white">Tracking:</span> Tracking information is provided upon dispatch via email.</li>
            </ul>
          </div>

          {/* EXCHANGES */}
          <div className="bg-gray-900 rounded-2xl p-6 shadow-md space-y-4">
            <h2 className="text-2xl font-bold text-white">Exchanges</h2>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li><span className="font-semibold text-white">Eligibility:</span> Applicable only for defective or damaged items.</li>
              <li><span className="font-semibold text-white">Exchange Process:</span> Contact support with your order number and issue description.</li>
              <li><span className="font-semibold text-white">Timeframe:</span> Requests must be submitted within 14 days of delivery.</li>
              <li><span className="font-semibold text-white">Condition of Item:</span> Must be unused and in original packaging.</li>
            </ul>
          </div>

          {/* RETURNS */}
          <div className="bg-gray-900 rounded-2xl p-6 shadow-md space-y-4">
            <h2 className="text-2xl font-bold text-white">Returns</h2>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li><span className="font-semibold text-white">Eligibility:</span> Only accepted for eligible physical products in original, unused condition.</li>
              <li><span className="font-semibold text-white">Return Process:</span> Email support to initiate the return and receive further instructions.</li>
              <li><span className="font-semibold text-white">Timeframe:</span> Requests must be made within 14 days of receiving the item.</li>
              <li><span className="font-semibold text-white">Condition of Item:</span> Must include original packaging and be in new condition.</li>
              <li><span className="font-semibold text-white">Return Shipping Costs:</span> Covered by the customer unless the product is defective.</li>
              <li><span className="font-semibold text-white">Damaged/Defective Items:</span> Share photos and issue details for fast replacement or refund.</li>
              <li><span className="font-semibold text-white">Non-Returnable Items:</span> Digital downloads, personalized products, and opened consumables are non-returnable.</li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="bg-gray-900 rounded-2xl p-6 shadow-md space-y-4">
            <h2 className="text-2xl font-bold text-white">Contact Us</h2>
            <p className="text-gray-300">
              If you have any questions or concerns about this policy, feel free to reach out at{' '}
              <a href="mailto:bristuappofficial@gmail.com" className="text-blue-400 underline hover:text-blue-300">
                bristuappofficial@gmail.com
              </a>.
            </p>
          </div>
        </section>
      </div>
    </div>
  )
}
